import { useEffect, useState } from 'react';
import Spin from 'antd/lib/spin';
import { Redirect } from 'react-router-dom';
import AppLayout from 'components/AppLayout';
import { initInternalization } from 'localization/localization';
import { isInitialSetupCompleted, termsAndConditionsAccepted } from 'utils/userUtils';
import './styles/App.less';
import { useDispatch, useSelector } from 'react-redux';
import { isAdminSelector, userSelector, userTagsSelector } from 'redux/selectors/userSelector';
import { checkUserRole, getUserInfo, getUserTags } from 'redux/reducers/authenticationSlice';
import { ContentProviderAccountDto } from './api';
import { AppDispatch } from './redux/store';
import { useAuth0 } from '@auth0/auth0-react';
import { isEmpty } from 'lodash';
import flagsmith from 'flagsmith';
import { FlagsmithProvider } from 'flagsmith/react';
import { getCountries } from 'redux/reducers/regionSlice';
import forgotPasswordConfig from 'auth/forgotPasswordConfig';

export default function App() {
	const [isLocaleInit, setIsLocaleInit] = useState(false);
	const { isLoading, user, getIdTokenClaims, loginWithRedirect, logout, isAuthenticated } = useAuth0();
	const userData = useSelector(userSelector);
	const isAdmin = useSelector(isAdminSelector);
	const userTags = useSelector(userTagsSelector);
	const dispatch: AppDispatch = useDispatch();
	const urlParams = new URLSearchParams(window.location.search);

	useEffect(() => {
		const init = async () => {
			await initInternalization();
			await dispatch(getCountries());
			if (!userData) {
				await dispatch(getUserInfo());
			}
			setIsLocaleInit(true);
		};
		init();
	}, [dispatch]);

	useEffect(() => {
		const init = async () => {
			if (userData?.userId && isInitialSetupCompleted(userData)) {
				dispatch(getUserTags(userData?.userId));
			}
		};
		init();
	}, [userData?.userId, userData]);

	useEffect(() => {
		const getUserClaims = async () => {
			await dispatch(checkUserRole(getIdTokenClaims));
		};
		getUserClaims();
	}, [user]);

	const redirectUser = (userData: ContentProviderAccountDto | null, userTags) => {
		if (!userData || !userData.emailVerified) {
			return <Redirect to="email-verification" />;
		} else if (!termsAndConditionsAccepted(userData)) {
			return <Redirect to="/toc" />;
		} else if (!isInitialSetupCompleted(userData)) {
			return <Redirect to="/profile-setup" />;
		} else {
			return <Redirect to="/profile-information" />;
		}
	};

	useEffect(() => {
		if (urlParams.get('forgotPassword') === 'true' && !isLoading) {
			console.log('isAuthenticated', isAuthenticated);
			if (isAuthenticated) {
				logout({
					returnTo: window.location.origin + '/?forgotPassword=true',
				});
				localStorage.clear();
			} else {
				loginWithRedirect(forgotPasswordConfig);
			}
		}
	}, [isLoading]);

	if (isLoading || !isLocaleInit || urlParams.get('forgotPassword') === 'true') return <Spin />;

	return (
		<>
			<AppLayout />
			{userData || user ? redirectUser(userData, userTags) : null}
		</>
	);
}
